(function () {
  if (window.__pcQuoteInit) return;
  window.__pcQuoteInit = true;

  var STOREFRONT_TOKEN = 'YOUR_STOREFRONT_API_TOKEN_HERE';
  var API_VERSION = '2026-10';
  var SHOP_DOMAIN = (window.Shopify && window.Shopify.shop) || window.location.hostname;
  var GRAPHQL_URL = 'https://' + SHOP_DOMAIN + '/api/' + API_VERSION + '/graphql.json';

  var US_STATES = [
    ['AL','Alabama'],['AK','Alaska'],['AZ','Arizona'],['AR','Arkansas'],['CA','California'],
    ['CO','Colorado'],['CT','Connecticut'],['DE','Delaware'],['DC','District of Columbia'],
    ['FL','Florida'],['GA','Georgia'],['HI','Hawaii'],['ID','Idaho'],['IL','Illinois'],
    ['IN','Indiana'],['IA','Iowa'],['KS','Kansas'],['KY','Kentucky'],['LA','Louisiana'],
    ['ME','Maine'],['MD','Maryland'],['MA','Massachusetts'],['MI','Michigan'],['MN','Minnesota'],
    ['MS','Mississippi'],['MO','Missouri'],['MT','Montana'],['NE','Nebraska'],['NV','Nevada'],
    ['NH','New Hampshire'],['NJ','New Jersey'],['NM','New Mexico'],['NY','New York'],
    ['NC','North Carolina'],['ND','North Dakota'],['OH','Ohio'],['OK','Oklahoma'],['OR','Oregon'],
    ['PA','Pennsylvania'],['RI','Rhode Island'],['SC','South Carolina'],['SD','South Dakota'],
    ['TN','Tennessee'],['TX','Texas'],['UT','Utah'],['VT','Vermont'],['VA','Virginia'],
    ['WA','Washington'],['WV','West Virginia'],['WI','Wisconsin'],['WY','Wyoming']
  ];

  function gql(query, variables) {
    return fetch(GRAPHQL_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
      },
      body: JSON.stringify({ query: query, variables: variables })
    }).then(function (r) { return r.json(); });
  }

  function findPriceEl() {
    return document.querySelector('[data-pdp-gallons]');
  }

  function toggleButtons() {
    var priceEl = findPriceEl();
    if (!priceEl) return;
    var gallons = parseInt(priceEl.getAttribute('data-pdp-gallons'), 10) || 0;
    var needsQuote = gallons === 55 || gallons === 275;

    // Compare against each element's OWN current state, not a remembered
    // global value. Dawn replaces both the standard-buy and quote-buy divs
    // with fresh server-rendered nodes on every variant change (confirmed
    // live: new DOM node each time), and a fresh node always starts back at
    // its server-rendered default (standard visible, quote hidden) no
    // matter what the previous variant's state was. A global "did the
    // logical value change" cache (the previous version of this function)
    // wrongly skipped re-applying the fix whenever two different variants
    // in a row both needed — or both didn't need — a quote, because the
    // *node* had silently been reset underneath it even though the
    // computed boolean hadn't changed. Reading el.hidden fresh each time
    // avoids that while still being a no-op (so still safe against
    // feedback loops) whenever a node genuinely wasn't replaced.
    document.querySelectorAll('.pc-standard-buy').forEach(function (el) {
      if (el.hidden !== needsQuote) el.hidden = needsQuote;
    });
    document.querySelectorAll('.pc-quote-buy').forEach(function (el) {
      if (el.hidden !== !needsQuote) el.hidden = !needsQuote;
    });
  }

  // Watch a stable ancestor instead of the price node itself, since Dawn
  // replaces the whole price div (not just its contents) on variant change
  // and that would silently kill an observer bound to that specific node.
  // IMPORTANT: this must stay scoped to the product section, never to
  // document.body — body-level mutation storms from lazy-loaded images,
  // cart-count badges, and third-party app scripts caused a feedback loop
  // that froze the tab ("page unresponsive") in the first version of this.
  function watchForVariantChanges() {
    toggleButtons();

    var priceEl = findPriceEl();
    // Every Online Store 2.0 section is wrapped in a .shopify-section div
    // with a stable id, so this is reliably scoped and reliably present —
    // unlike guessing at Dawn's internal class names.
    var container = priceEl ? priceEl.closest('.shopify-section') : null;

    if (container) {
      var observer = new MutationObserver(function () {
        toggleButtons();
      });
      observer.observe(container, { childList: true, subtree: true, attributes: true });
    }

    // Primary, cheap signal: the variant picker's underlying inputs fire a
    // native 'change' event the instant a size is picked, well before Dawn's
    // AJAX re-render finishes. Re-check a couple of times after that so we
    // catch the moment data-pdp-gallons actually updates, without polling
    // continuously.
    document.addEventListener('change', function (e) {
      if (e.target.closest('variant-selects, product-form, fieldset')) {
        setTimeout(toggleButtons, 250);
        setTimeout(toggleButtons, 600);
        setTimeout(toggleButtons, 1200);
      }
    });

    // Belt-and-suspenders for themes/apps that use styled buttons/labels
    // instead of native inputs under the hood.
    document.addEventListener('click', function (e) {
      if (e.target.closest('variant-selects, product-form, [name^="options"], fieldset')) {
        setTimeout(toggleButtons, 250);
        setTimeout(toggleButtons, 600);
        setTimeout(toggleButtons, 1200);
      }
    });
  }

  var modalEl = null;

  function buildModal() {
    if (modalEl) return modalEl;
    modalEl = document.createElement('div');
    modalEl.className = 'pc-quote-modal';
    modalEl.hidden = true;
    modalEl.innerHTML =
      '<div class="pc-quote-modal__backdrop" data-pc-quote-close></div>' +
      '<div class="pc-quote-modal__dialog" role="dialog" aria-modal="true" aria-label="Request a shipping quote">' +
        '<button type="button" class="pc-quote-modal__close" data-pc-quote-close aria-label="Close">&times;</button>' +
        '<p class="pc-quote-eyebrow">FREIGHT SHIPPING</p>' +
        '<h3 class="pc-quote-heading">Request a <span>Shipping Quote</span></h3>' +
        '<p class="pc-quote-desc">This size ships via freight. Leave your details and our team will follow up with a shipping quote.</p>' +
        '<form class="pc-quote-form" autocomplete="off">' +
          '<div class="pc-quote-field">' +
            '<label class="pc-quote-label" for="pc-quote-phone">Phone Number <span class="pc-quote-required">*</span></label>' +
            '<input class="pc-quote-input" id="pc-quote-phone" type="tel" name="phone" placeholder="Enter your phone number" required>' +
          '</div>' +
          '<div class="pc-quote-field">' +
            '<label class="pc-quote-label" for="pc-quote-email">Email Address <span class="pc-quote-required">*</span></label>' +
            '<input class="pc-quote-input" id="pc-quote-email" type="email" name="email" placeholder="Enter your email" required>' +
          '</div>' +
          '<div class="pc-quote-field pc-quote-combo-wrap">' +
            '<label class="pc-quote-label" for="pc-quote-state">State <span class="pc-quote-required">*</span></label>' +
            '<input class="pc-quote-input" id="pc-quote-state" type="text" role="combobox" aria-autocomplete="list" aria-expanded="false" autocomplete="off" placeholder="Type to search a state" required>' +
            '<input type="hidden" name="state">' +
            '<ul class="pc-quote-combo-list" hidden></ul>' +
          '</div>' +
          '<div class="pc-quote-field">' +
            '<label class="pc-quote-label" for="pc-quote-zip">Zip Code <span class="pc-quote-required">*</span></label>' +
            '<input class="pc-quote-input" id="pc-quote-zip" type="text" name="zip" maxlength="10" placeholder="Enter your zip code" required>' +
          '</div>' +
          '<button type="submit" class="pc-quote-submit">Request Quote</button>' +
          '<p class="pc-quote-status" aria-live="polite"></p>' +
        '</form>' +
      '</div>';
    document.body.appendChild(modalEl);

    modalEl.addEventListener('click', function (e) {
      if (e.target.hasAttribute('data-pc-quote-close')) closeModal();
    });

    setupStateCombo(modalEl);
    modalEl.querySelector('.pc-quote-form').addEventListener('submit', onSubmit);
    return modalEl;
  }

  function setupStateCombo(root) {
    var input = root.querySelector('#pc-quote-state');
    var hidden = root.querySelector('input[name="state"]');
    var list = root.querySelector('.pc-quote-combo-list');
    var activeIndex = -1;
    var matches = [];

    function render(filter) {
      var q = (filter || '').trim().toLowerCase();
      matches = US_STATES.filter(function (s) {
        return s[1].toLowerCase().indexOf(q) === 0 || s[0].toLowerCase() === q;
      });
      if (!q) matches = US_STATES.slice();

      if (!matches.length) {
        list.hidden = true;
        list.innerHTML = '';
        return;
      }

      list.innerHTML = matches.map(function (s, i) {
        return '<li role="option" data-code="' + s[0] + '" data-name="' + s[1] + '" class="' + (i === activeIndex ? 'is-active' : '') + '">' + s[1] + '</li>';
      }).join('');
      list.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function select(code, name) {
      hidden.value = code;
      input.value = name;
      list.hidden = true;
      input.setAttribute('aria-expanded', 'false');
    }

    input.addEventListener('input', function () {
      hidden.value = '';
      activeIndex = -1;
      render(input.value);
    });

    input.addEventListener('focus', function () {
      render(input.value);
    });

    input.addEventListener('keydown', function (e) {
      if (list.hidden && e.key !== 'Escape') return;
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        activeIndex = Math.min(activeIndex + 1, matches.length - 1);
        render(input.value);
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        activeIndex = Math.max(activeIndex - 1, 0);
        render(input.value);
      } else if (e.key === 'Enter') {
        if (activeIndex >= 0 && matches[activeIndex]) {
          e.preventDefault();
          select(matches[activeIndex][0], matches[activeIndex][1]);
        }
      } else if (e.key === 'Escape') {
        list.hidden = true;
      }
    });

    list.addEventListener('mousedown', function (e) {
      var li = e.target.closest('li');
      if (!li) return;
      select(li.getAttribute('data-code'), li.getAttribute('data-name'));
    });

    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) return;
      if (!e.target.closest('.pc-quote-combo-wrap')) list.hidden = true;
    });
  }

  // The variant a submitted quote request is attached to. Normally this is
  // the PDP's currently selected variant, but openModal can be called with
  // an explicit variantId too (see below) so product-card triggers can
  // reuse this same modal for whichever pack size is active on that card.
  var activeQuoteVariantId = null;

  function openModal(variantId) {
    if (variantId) {
      activeQuoteVariantId = variantId;
    } else {
      var priceEl = findPriceEl();
      activeQuoteVariantId = priceEl ? priceEl.getAttribute('data-pdp-variant-id') : null;
    }
    buildModal().hidden = false;
    document.body.classList.add('pc-quote-modal-open');
  }

  function closeModal() {
    if (modalEl) modalEl.hidden = true;
    document.body.classList.remove('pc-quote-modal-open');
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modalEl && !modalEl.hidden) closeModal();
  });

  // Best-effort email notification via Shopify's own built-in contact form
  // handler (Settings > Notifications sets which inbox receives it). This
  // is a native Shopify feature, not a third-party integration, so it adds
  // a guaranteed "someone gets notified" path alongside the cart that
  // doesn't depend on whether the cart itself ever surfaces as an
  // abandoned checkout in admin. Fired in parallel with cartCreate; never
  // blocks or affects the form's own success/error message.
  function notifyByEmail(data) {
    var body = new URLSearchParams({
      form_type: 'contact',
      utf8: '✓',
      'contact[name]': 'Shipping Quote Request',
      'contact[email]': data.email,
      'contact[phone]': data.phone,
      'contact[body]':
        'Freight shipping quote requested.\n' +
        'State: ' + data.state + '\n' +
        'Zip: ' + data.zip + '\n' +
        'Product page: ' + window.location.href
    });
    fetch('/contact', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: body.toString()
    }).catch(function () {
      // Silent: this is a backup notification channel, not the primary
      // success/failure signal shown to the shopper.
    });
  }

  function onSubmit(e) {
    e.preventDefault();
    var form = e.target;
    var statusEl = form.querySelector('.pc-quote-status');
    var submitBtn = form.querySelector('.pc-quote-submit');
    var variantId = activeQuoteVariantId;

    var phone = form.phone.value.trim();
    var email = form.email.value.trim();
    var state = form.state.value;
    var zip = form.zip.value.trim();

    statusEl.classList.remove('pc-quote-status-success', 'pc-quote-status-error');

    if (!state) {
      statusEl.textContent = 'Please choose a state from the list.';
      statusEl.classList.add('pc-quote-status-error');
      return;
    }

    submitBtn.disabled = true;
    statusEl.textContent = 'Submitting...';

    notifyByEmail({ email: email, phone: phone, state: state, zip: zip });

    var lines = [];
    if (variantId) {
      lines.push({ merchandiseId: 'gid://shopify/ProductVariant/' + variantId, quantity: 1 });
    }

    var createQuery =
      'mutation($input: CartInput!) {' +
      '  cartCreate(input: $input) {' +
      '    cart { id checkoutUrl }' +
      '    userErrors { field message }' +
      '  }' +
      '}';

    var cartInput = {
      lines: lines,
      buyerIdentity: { email: email, phone: phone },
      attributes: [
        { key: 'Requested State', value: state },
        { key: 'Requested Zip', value: zip },
        { key: 'Quote Request', value: 'Freight shipping quote requested via product page' }
      ]
    };

    gql(createQuery, { input: cartInput }).then(function (res) {
      var payload = res && res.data && res.data.cartCreate;
      if (!payload || (payload.userErrors && payload.userErrors.length)) {
        statusEl.textContent = 'Something went wrong. Please call us directly for a quote.';
        statusEl.classList.add('pc-quote-status-error');
        submitBtn.disabled = false;
        return;
      }

      var cartId = payload.cart.id;

      var addressQuery =
        'mutation($id: ID!, $addresses: [CartSelectableAddressInput!]!) {' +
        '  cartDeliveryAddressesAdd(cartId: $id, addresses: $addresses) {' +
        '    cart { id }' +
        '    userErrors { field message }' +
        '  }' +
        '}';

      gql(addressQuery, {
        id: cartId,
        addresses: [{
          selected: true,
          address: {
            deliveryAddress: {
              provinceCode: state,
              zip: zip,
              countryCode: 'US'
            }
          }
        }]
      }).finally(function () {
        statusEl.textContent = 'Thanks! Our team will reach out shortly with your shipping quote.';
        statusEl.classList.add('pc-quote-status-success');
        form.reset();
        submitBtn.disabled = false;
        setTimeout(closeModal, 2500);
      });
    }).catch(function () {
      statusEl.textContent = 'Something went wrong. Please call us directly for a quote.';
      statusEl.classList.add('pc-quote-status-error');
      submitBtn.disabled = false;
    });
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-pc-quote-open]');
    if (trigger) {
      openModal(trigger.getAttribute('data-variant-id') || null);
    }
  });

  // Exposed so other scripts (e.g. the product-card freight toggle) can
  // open this same modal for a specific variant without duplicating the
  // modal markup, CSS, or Cart API calls.
  window.ProCleanQuote = { open: openModal };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchForVariantChanges);
  } else {
    watchForVariantChanges();
  }
})();